/* eslint-disable @typescript-eslint/no-explicit-any */
import core from "domain/core/reducers";
import { combineReducers } from "redux";

const appReducer = combineReducers({ core });

const reducer = (state: any, action: any) => {
  if (action.type === "RESET") {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default reducer;
